import { Button, Loader, Panel, PanelHeader, PanelBody, PanelFooter, PanelRow, PanelCell } from '@teamsnap/teamsnap-ui';

import { DateService, DateFormat } from 'frontend-toolkit';

import * as React from 'react';
import AppStateStore from '../../stores/app-state-store';
import FormElementHook from './form-element-hook';
import { useForm } from 'react-hook-form';

import * as AddMember from '../../core/gql/mutations/add-member';
import * as _ from 'lodash';
import { useMutation } from '@apollo/client';
import { reactiveFeedbackMessage } from '../../core/apollo-cache';

const CreateElement = FormElementHook as new () => FormElementHook;

export interface Props {
  appStateStore?: AppStateStore;
  orgId: number;
}

const MemberEditForm: React.FunctionComponent<Props> = ({ appStateStore, orgId }) => {
  const [addMember, addMemberResponse] = useMutation(AddMember.MUTATION);
  const memberForm = useForm();

  // TODO: React to the state of the request
  const isSubmitting = addMemberResponse.loading;

  const { handleSubmit, register } = memberForm;

  return (
    <form
      onSubmit={handleSubmit(async ({ firstName, lastName, birthdate, gender }) => {
        try {
          const addMemberResponse = await addMember({
            variables: {
              organizationId: orgId,
              firstName,
              lastName,
              birthdate: DateService.dateToString(birthdate, DateFormat.YYYY_MM_DD),
              gender,
            },
          });

          if (addMemberResponse?.data?.createMember?.id) {
            reactiveFeedbackMessage({
              message: `${firstName} ${lastName} has been added to your organization.`,
              autoclose: true,
              isError: false,
            });
          } else {
            reactiveFeedbackMessage({
              message: `Unable to add ${firstName} ${lastName} to your organization.`,
              autoclose: false,
              isError: true,
            });
          }
        } catch (e) {
          reactiveFeedbackMessage({
            message: `Unable to add ${firstName} ${lastName} to your organization.`,
            autoclose: false,
            isError: true,
          });
        }
      })}
    >
      <div id="organization-create-editor-content" className="page-content">
        <h2 className="page-content-header">Members / New</h2>

        <Panel mods="Panel--form">
          <PanelHeader title="Member Info" />
          <PanelBody>
            <PanelRow isWithCells={true} mods="Panel-row--header">
              <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
                <h4>First Name</h4>
              </PanelCell>
              <PanelCell mods="u-size9of12">
                <CreateElement
                  inputRef={register({
                    required: 'You must enter a first name.',
                  })}
                  useHookResponse={memberForm}
                  type="text"
                  field="firstName"
                  label="Organization Name"
                  labelHidden={true}
                  placeholder="first name"
                />
              </PanelCell>
            </PanelRow>
            <PanelRow isWithCells={true} mods="Panel-row--header">
              <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
                <h4>Last Name</h4>
              </PanelCell>
              <PanelCell mods="u-size9of12">
                <CreateElement
                  inputRef={register({
                    required: 'You must enter a last name.',
                  })}
                  useHookResponse={memberForm}
                  type="text"
                  field="lastName"
                  label="Organization Name"
                  labelHidden={true}
                  placeholder="Last name"
                />
              </PanelCell>
            </PanelRow>
            <PanelRow isWithCells={true} mods="Panel-row--header">
              <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
                <h4>Birthday</h4>
              </PanelCell>
              <PanelCell mods="u-size9of12">
                <CreateElement
                  // inputRef={register({
                  //   required: "You must enter a birthdate.",
                  // })}
                  useHookResponse={memberForm}
                  type="date"
                  field="birthdate"
                  label="This should be a date selector"
                  labelHidden={true}
                  dateProps={{ maxDate: new Date() }}
                />
              </PanelCell>
            </PanelRow>
            <PanelRow isWithCells={true} mods="Panel-row--header">
              <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
                <h4>Gender</h4>
              </PanelCell>
              <PanelCell mods="u-size9of12">
                <CreateElement
                  useHookResponse={memberForm}
                  inputRef={register({
                    required: false,
                  })}
                  type="select"
                  field="gender"
                  placeholder="Gender"
                  options={[
                    { value: '', text: 'No Selection' },
                    { value: 'Male', text: 'Male' },
                    { value: 'Female', text: 'Female' },
                  ]}
                />
              </PanelCell>
            </PanelRow>
          </PanelBody>
          <PanelFooter mods="u-textLeft">
            <div className="button-list">
              <Button isDisabled={isSubmitting} color="primary" icon={isSubmitting ? null : 'check'} type="submit">
                {isSubmitting && <Loader type="spin" style={{ width: '13px', height: '13px' }} />}
                Save
              </Button>
            </div>
          </PanelFooter>
        </Panel>
      </div>
    </form>
  );
};

export default MemberEditForm;
